<div class="layout-container rx-app-flex-container-row rx-app-flex-container-row--justify-center">
    <div class="modeling-container">
        <div class="modeling-components-container rx-app-flex-container-column">
            <div class="hide-disable-ordersection">
                <ng-container [ngSwitch]="isProcedureFlow$ | async" #orderContainer>
                    <div *ngSwitchCase="true">
                        <rx-procedure-flow-order></rx-procedure-flow-order>
                        <rx-denture-details *ngIf="isDentureDetailsVisible$ | async"></rx-denture-details>
                    </div>
                    <rx-case-type-flow-order *ngSwitchCase="false"></rx-case-type-flow-order>
                </ng-container>
            </div>
            <ng-container [ngSwitch]="isProcedureFlow$ | async">
                <rx-general-data-v1 *ngSwitchCase="true"></rx-general-data-v1>
                <rx-general-data-v0 *ngSwitchCase="false"></rx-general-data-v0>
            </ng-container>
            <rx-denture-details-info [rx]="rx$ | async" [isResponsive]="true" *ngIf="procedureId$ | async | mapper : isDentureDetailsVisible">
            </rx-denture-details-info>
			<rx-scan-options-lab [rx]="rx$ | async"></rx-scan-options-lab>
            <div *ngIf="isRestoOrder$ | async">
                <rx-teeth-diagram [isProcedureFlow]="isProcedureFlow$ | async" [isRxForModeling]="true"></rx-teeth-diagram>
                <rx-treatment-information [isProcedureFlow]="isProcedureFlow$ | async"></rx-treatment-information>
                <rx-order-information></rx-order-information>
            </div>
            <div *ngIf="isNotesVisible$ | async" class="notes-section-container rx-app-flex-container-row rx-app-flex-container-row--justify-space-between">
                <rx-notes class="notes-section-item" [role]="role"></rx-notes>
                <rx-aligntech-notes class="notes-section-item"></rx-aligntech-notes>
            </div>
        </div>
    </div>
</div>
